module.exports = __webpack_public_path__ + "static/media/img-poster.3ee4d41e.svg";